import {
  getRequest,
  postRequest
} from '@/utils/api'

export function listEquipment(params) {
  return postRequest('/api/coo/equipment/list', params)
}

export function getEquipment(id) {
  return postRequest('/api/coo/equipment/get', { id })
}

export function addEquipment(data) {
  return postRequest('/api/coo/equipment/add', data)
}

export function updateEquipment(data) {
  return postRequest('/api/coo/equipment/update', data)
}

export function delEquipment(id) {
  return postRequest('/api/coo/equipment/delete', { id })
}

export function pushEquipment(id) {
  return postRequest('/api/coo/equipment/push', { id })
}

export function batchPushEquipment(data) {
  return postRequest('/api/coo/equipment/push-batch', data)
}

export function importEquipment(data) {
  return postRequest('/api/coo/equipment/import', data)
}

export function exportEquipment(params) {
  return getRequest('/api/coo/equipment/export', params)
}

export function listPushLog(params) {
  return postRequest('/api/coo/push/log/list', params)
}

export function retryPush(id) {
  return postRequest('/api/coo/push/log/retry', { id })
}
